export default {"src":"/_next/static/media/mail.5a551f06.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};